module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-289.57689c9.woff2";